import React, { Suspense } from "react";
import { Form, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { Await, useLoaderData } from "react-router-dom";

export default function ContentGroupsPicker({ formData, setFormData, name, filterFunction = () => true, labelVisible = true, customClass = "", open = false }) {
    const { contentGroups } = useLoaderData();

    return (
        <Suspense fallback={<Fallback name={name} />}>
            <Await resolve={contentGroups}>
                {resolvedContentGroups => (
                    <Form.Group as={Col} className={`${customClass}`}>
                        {labelVisible && <Form.Label>Content Groups</Form.Label>}
                        <Typeahead
                            id={`${name}-content-groups-selection`}
                            options={resolvedContentGroups.data.filter(filterFunction)}
                            labelKey={"display_name"}
                            multiple
                            highlightOnlyResult
                            clearButton
                            onChange={value => setFormData({ ...formData, contentGroups: value })}
                            selected={formData.contentGroups}
                            placeholder="Select content groups"
                            defaultOpen={open}
                        />
                    </Form.Group>
                )}
            </Await>
        </Suspense>
    );
}

function Fallback({ name }) {
    return (
        <Form.Group as={Col} className="col-12 col-xl-5">
            <Form.Label>Content Groups</Form.Label>
            <Typeahead id={`${name}-content-groups-selection-fallback`} options={[]} placeholder="Loading content groups..." disabled />
        </Form.Group>
    );
}
